import { render, staticRenderFns } from "./BusinessEmployeesInvite.vue?vue&type=template&id=3fda4dff"
import script from "./BusinessEmployeesInvite.vue?vue&type=script&lang=js"
export * from "./BusinessEmployeesInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSiteInput: require('/opt/atlassian/pipelines/agent/build/components/form/SiteInput.vue').default,FormButton: require('/opt/atlassian/pipelines/agent/build/components/form/FormButton.vue').default})
